import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Paper, Typography } from "@material-ui/core";
import { DataGridCystellarTable } from "../util/DataGridCystellarTable";

import {
  tableCellRender,
  stringFilterOperators,
  dateFilterOperators,
  formatDateValue,
} from "../util/tableUtils";
import { goToClaimPage } from "../claim/utils";

export const PolicyClaimsList = (props) => {
  const { t } = useTranslation();

  const claimOutcomeMap = {
    A: `A-${t("claims.open")}`,
    C: `C-${t("claims.closed")}`,
    S: `S-${t("claims.noRenewal")}`,
  };

  const claimColumns = [
    {
      field: "claimCode",
      headerName: t("claims.claimCode"),
    },
    {
      field: "referenceDate",
      headerName: t("coverage.year"),
    },
    {
      field: "claimEventDate",
      headerName: t("claims.claimEventDate"),
      sortable: false,
      type: "date",
      filterOperators: dateFilterOperators,
      valueGetter: (params) => (params.row.claimEventDate ? formatDateValue(params.row.claimEventDate) : ""),
    },
    {
      field: "perilGroup",
      headerName: t("perilGroup.title"),
    },
    {
      field: "perilName",
      headerName: t("perilName"),
    },
    {
      field: "claimCauseDescription",
      headerName: t("claims.claimCause"),
    },
    {
      field: "claimOutcome",
      headerName: t("claims.claimOutcome"),
      valueGetter: (param) => claimOutcomeMap[param.row.claimOutcome],
    },
    {
      field: "claimLoadTotalAmount",
      headerName: t("claims.claimAmount"),
    },
  ];

  const columns = claimColumns.map((tableColumn) => ({
    valueFormatter: (params) => tableCellRender(params.value),
    filterOperators: stringFilterOperators,
    width: 150,
    ...tableColumn,
  }));

  return (
    <Box pt={1}>
      <Paper>
        <Box p={2} pt={2}>
          <Typography
            variant={"h2"}
            component={"span"}
            style={{
              fontSize: "1.3rem",
              fontWeight: 400,
            }}
          >
            {t("claims.title")}
          </Typography>
        </Box>
        <div style={{ maxHeight: "40vw", maxWidth: "100%", overflow: "auto" }}>
          <DataGridCystellarTable
            columns={columns}
            rows={props?.claims}
            rowCount={props?.claims?.length}
            getRowId={(rowData) => rowData._id}
            onRowClick={(rowData) => goToClaimPage(rowData.row)}
            pagination={false}
            loading={props.isLoading}
            customToolbarComp={true}
            customToolbarCompMsg={props.lastUpdate}
            customNoRowsMsg={t("policy.emptyClaimsList")}
          />
        </div>
      </Paper>
    </Box>
  );
};
